// Constants for CivicDuty application
// This file centralizes all hardcoded values to make the app more maintainable

// Political Parties
export const POLITICAL_PARTIES = {
  REPUBLICAN: 'republican',
  DEMOCRAT: 'democrat',
  INDEPENDENT: 'independent'
};

// Government Branches
export const GOVERNMENT_BRANCHES = {
  LEGISLATIVE: 'legislative',
  EXECUTIVE: 'executive',
  JUDICIAL: 'judicial',
  GOVERNMENT_OFFICIAL: 'government official'
};

// Locality Levels
export const LOCALITY_LEVELS = {
  FEDERAL: 'federal',
  STATE: 'state',
  LOCAL: 'local',
  UNKNOWN: 'unknown'
};

// Default Values
export const DEFAULT_VALUES = {
  UNKNOWN: 'N/A',
  PRESENT: 'N/A',
  ALL: 'all',
  NONE: 'none',
  NA: 'N/A'
};

// Grouping Options
export const GROUPING_OPTIONS = {
  NONE: 'none',
  BRANCH: 'branch',
  OFFICE: 'office',
  LOCALITY: 'locality'
};

// Profile View Modes
export const PROFILE_VIEW_MODES = {
  UPDATES: 'updates',
  VOTING: 'voting',
  SOCIAL_MEDIA: 'social_media',
  COMMITTEES: 'committees',
  SPONSORED: 'sponsored'
};

// Filter Options
export const FILTER_OPTIONS = {
  ALL: 'all',
  APPROVED: 'approved',
  UNAPPROVED: 'unapproved'
};

// Note: All office classifications, position descriptions, and hardcoded values 
// should come from the MongoDB database via the admin server.
// These constants are kept minimal and only for UI state management.

// Empty-state messages for About the Person / About the Position when legislator hasn't submitted info.
// hasRequestAccessBlock: true when the Request Access CTA is visible above (no social links).
export const getEmptyBioMessage = (hasRequestAccessBlock) => {
  if (hasRequestAccessBlock) {
    return 'This section is filled in once this legislator fills out a short informational form. See above to learn how your representative can get a full profile.';
  }
  return 'This section is filled in once this legislator fills out a short informational form. Legislators can email us from their official address to get started.';
};

// Fallback Messages
export const FALLBACK_MESSAGES = {
  NO_BIOGRAPHY: 'N/A',
  NO_RECENT_ACTIVITY: 'N/A',
  NO_RECENT_ACTIVITY_IN_TAG: 'N/A',
  PROCESSING: 'N/A',
  UNTITLED_PRESS_RELEASE: 'N/A',
  NO_OFFICE_INFO: 'N/A',
  NO_LOCATION_INFO: 'N/A',
  NO_PARTY_INFO: 'N/A',
  NO_WEBSITE: 'N/A',
  NO_TERM_INFO: 'N/A'
};
